import _ from 'lodash';
import moment from 'moment';

import useInvoiceHistory from '../../../hooks/subscriptions/useInvoiceHistory';
import Loader from '../../generic/Loader';
import Link from '../../generic/Link';
import type { StripeInvoice } from '../../../../typings/stripe';

const getInvoiceRows = (invoices: StripeInvoice[]) => {
  if (_.isEmpty(invoices)) {
    return <div className="invoices-empty">No invoices found.</div>;
  }

  const sortedInvoices = _.orderBy(invoices, 'created', 'desc');
  const invoiceRows = sortedInvoices.map((invoiceObject, idx) => {
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(invoiceObject.total / 100);

    const formattedDate = moment(invoiceObject.created * 1000).format('MMM YYYY');

    return (
      <div className="invoice-row" key={invoiceObject.created}>
        <span className="invoice-row--content">
          <span>Invoice #{sortedInvoices.length - idx}</span>
          <span>{formattedDate.toString()}</span>
          <span>{formattedPrice}</span>
          <span>
            <Link to={invoiceObject.hosted_invoice_url} openInNewTab>
              View Invoice
            </Link>
          </span>
        </span>
      </div>
    );
  });

  return invoiceRows;
};

const InvoiceHistoryContent = () => {
  const { invoices, status } = useInvoiceHistory();

  return (
    <div className="invoice-history-container">
      {status.loading ? (
        <Loader />
      ) : (
        <>
          <div className="invoice-row invoice-row--content invoice-row--header">
            <span>Invoice</span>
            <span>Date</span>
            <span>Amount</span>
          </div>
          {getInvoiceRows(invoices)}
        </>
      )}
    </div>
  );
};

export default InvoiceHistoryContent;
